/** Живые события сервера (SSE /api/events): одно соединение на вкладку, подписки по типу события.
 *  EventSource сам переподключается после обрыва; после переподключения подписчики получают «hello» и перечитывают данные. */
import { apiUrl } from "./api";

type Listener = (data: unknown) => void;

const listeners = new Map<string, Set<Listener>>();
let source: EventSource | null = null;

function ensure() {
  if (source || typeof EventSource === "undefined") return;
  source = new EventSource(apiUrl("/events"), { withCredentials: true });
  for (const type of listeners.keys()) attach(type);
}

function attach(type: string) {
  source?.addEventListener(type, (e) => {
    let data: unknown = null;
    try {
      data = JSON.parse((e as MessageEvent).data);
    } catch {
      /* пустое событие */
    }
    listeners.get(type)?.forEach((fn) => fn(data));
  });
}

export function onServerEvent(type: string, fn: Listener): () => void {
  if (!listeners.has(type)) {
    listeners.set(type, new Set());
    attach(type);
  }
  listeners.get(type)?.add(fn);
  ensure();
  return () => {
    listeners.get(type)?.delete(fn);
    if ([...listeners.values()].every((s) => s.size === 0)) {
      source?.close();
      source = null;
    }
  };
}
